import { useCallback } from 'react';
import { useLocalStorage } from 'react-use';
import app from '@frontastic/catwalk/src/js/app/app';
import { useSelector } from 'react-redux';

export const useGeoIp = () => {
  // Setup localstorage hook
  const [isoCode, setIsoCode] = useLocalStorage('isoCode');
  const {
    locale,
    project: { configuration },
  } = useSelector((state) => state.app.context);

  // Setting GeoIp value on localstorage once per site visit
  // this does not account for immediate changes via VPN
  const setGeoIp = useCallback(async () => {
    // Only if we don't have geoIp value in
    // localstorage we run call to API and set responce on localstorage value
    if (!isoCode) {
      try {
        await app.getApi().request(
          'GET',
          'Apg.GeoIP.Get.Country.Code',
          null,
          null,
          (data) => {
            setIsoCode(data?.isoCode);
          },
          (error) => {
            console.log(error);
          },
        );
      } catch (error) {
        console.log(error);
      }
    }
  }, [isoCode, setIsoCode]);

  // Get allowed countries from configuration and check if passed country in among the allowed ones
  const getIsInAllowedCoutries = useCallback(
    (country) => {
      const allowedShippingCountries = configuration?.allowedShippingCountries;
      const countries = allowedShippingCountries?.codes;
      return countries?.includes(country);
    },
    [configuration],
  );

  // Get our country code that we then set on cart
  const getCountryToUpdate = useCallback(
    (cartCountry) => {
      const currentLocale = locale === 'en_AU@NZD' ? 'NZ' : 'AU';
      if (currentLocale === 'AU') {
        // if current site is AU and we have valid country from GeoIp and we have no country on cart
        // then set valid country code on cart
        if (getIsInAllowedCoutries(isoCode) && !cartCountry) {
          return isoCode;
        }

        // if we do have country on cart and that country is NZ or not allowed country
        // then force set country to AU
        if (
          (cartCountry && cartCountry === 'NZ') ||
          !getIsInAllowedCoutries(isoCode)
        ) {
          return 'AU';
        }
      }

      // If site locale is NZ and we don't have country on cart or country on cart is not NZ then set country to NZ
      if (currentLocale === 'NZ') {
        if (!cartCountry || cartCountry !== 'NZ') {
          return 'NZ';
        }
      }
      return null;
    },
    [locale, isoCode],
  );

  return {
    setGeoIp,
    isoCode,
    getCountryToUpdate,
  };
};
